import Vue from 'vue';
import CheckoutWrapper from '@/layout/CheckoutWrapper.vue';
import { mapState } from 'vuex';
import SubCategoryModal from '@/components/SubCategoryModal.vue';
import { trackEvent } from '@/services/analytics.js';
export default Vue.extend({
    name: 'PaymentFailurePage',
    components: {
        CheckoutWrapper,
        SubCategoryModal,
    },
    computed: {
        ...mapState('checkoutModule', ['settledOrder']),
        pageTitle() {
            return 'Payment issue';
        },
        orderMeta() {
            const o = this.settledOrder;
            if (!o)
                return null;
            const amountDue = typeof o.total === 'number' && o.currency
                ? this.formatMoney(o.total, o.currency)
                : undefined;
            return {
                orderRef: o.orderRef || o.id,
                amountDue,
                paymentMethod: o.paymentMethod,
            };
        },
        failureReason() {
            const o = this.settledOrder;
            return o?.lastFailureReason || null;
        },
        canRetry() {
            const o = this.settledOrder;
            return !!o?.canRetry && !!o?.retryRouteName;
        },
        retryRoute() {
            const o = this.settledOrder;
            return o?.retryRouteName ? { name: o.retryRouteName } : null;
        },
        orderDetailRoute() {
            const o = this.settledOrder;
            return o?.id ? { name: 'order.details', params: { id: o.id } } : null;
        },
        support() {
            // Adjust to your real channels
            // Prefer tel: for mobile users in SG; fallback to mailto:
            const tel = '+65 0000 0000';
            const email = 'support@example.com';
            const href = `tel:${tel.replace(/\s+/g, '')}`; // or `mailto:${email}`
            return { href, label: tel };
        },
    },
    created() {
        if (!this.settledOrder) {
            this.$router.replace('/cart');
            return;
        }
    },
    watch: {
        // If the Vuex state changes and order disappears, go back gracefully
        settledOrder(newVal) {
            if (!newVal)
                this.$router.replace('/cart');
        },
    },
    mounted() {
        // Move screen reader/keyboard focus to the heading
        this.$nextTick(() => {
            this.$refs.heading?.focus();
        });
        trackEvent('checkout_payment_error', {
            checkout_step: '2c2p_payment_failure',
        });
    },
    methods: {
        formatMoney(minorUnits, currency) {
            try {
                // If your totals are stored in cents, convert to units:
                const value = minorUnits > 1000 ? minorUnits / 100 : minorUnits; // adjust if you already store major units
                return new Intl.NumberFormat(undefined, {
                    style: 'currency',
                    currency,
                }).format(value);
            }
            catch {
                return `${minorUnits} ${currency}`;
            }
        },
        track(action) {
            // No-op analytics helper—safe if GA not installed
            try {
                // @ts-ignore
                this.$ga && this.$ga.event('payment_failure', action);
            }
            catch {
                /* ignore */
            }
        },
    },
});
